import { render, staticRenderFns } from "./MatchDistributioHeader.vue?vue&type=template&id=41f96065&scoped=true&"
var script = {}
import style0 from "./MatchDistributioHeader.vue?vue&type=style&index=0&id=41f96065&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f96065",
  null
  
)

export default component.exports